import React, { useState } from 'react';
import './HjelpSide.css';

export default function HjelpSide() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeModule, setActiveModule] = useState('oversikt');

  const modules = [
    { id: 'oversikt', icon: '🏠', name: 'Oversikt' },
    { id: 'saker', icon: '📁', name: 'Saksbehandling' },
    { id: 'klienter', icon: '👥', name: 'Klientadministrasjon' },
    { id: 'oppgaver', icon: '✅', name: 'Oppgaver & TODO' },
    { id: 'epost', icon: '📧', name: 'E-postsystem' },
    { id: 'bevis', icon: '🔍', name: 'Bevissystem' },
    { id: 'faktura', icon: '💰', name: 'Fakturasystem' },
    { id: 'tidsregistrering', icon: '⏱️', name: 'Tidsregistrering' },
    { id: 'forsikring', icon: '🛡️', name: 'Forsikring' },
    { id: 'kyc', icon: '🔐', name: 'KYC / Hvitvasking' },
    { id: 'ai', icon: '🤖', name: 'AI & Knowledge Base' },
    { id: 'microsoft', icon: '🔄', name: 'Microsoft Integrasjon' },
    { id: 'api', icon: '⚙️', name: 'API Dokumentasjon' }
  ];

  const handleOpenFullGuide = () => {
    // Åpne den fullstendige HTML-bruksanvisningen i nytt vindu
    // Bruk fetch for å laste HTML og åpne i nytt vindu
    fetch('/BRUKSANVISNING_INTERAKTIV.html')
      .then(res => res.text())
      .then(html => {
        const newWindow = window.open('', '_blank');
        newWindow.document.write(html);
        newWindow.document.close();
      })
      .catch(error => {
        console.error('Kunne ikke laste bruksanvisning:', error);
        alert('Kunne ikke åpne bruksanvisningen. Se konsollen for detaljer.');
      });
  };

  return (
    <div className="hjelp-side">
      <div className="hjelp-header">
        <h1>📚 Hjelp & Dokumentasjon</h1>
        <p>Finn svar på spørsmål om AdvokatCRM</p>
        <button className="full-guide-btn" onClick={handleOpenFullGuide}>
          📖 Åpne Fullstendig Bruksanvisning
        </button>
      </div>

      <div className="hjelp-search">
        <input
          type="text"
          placeholder="🔍 Søk etter funksjoner, moduler eller nøkkelord..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="hjelp-content-wrapper">
        <aside className="hjelp-sidebar">
          <h3>MODULER</h3>
          <ul>
            {modules.map(module => (
              <li
                key={module.id}
                className={activeModule === module.id ? 'active' : ''}
                onClick={() => setActiveModule(module.id)}
              >
                <span className="module-icon">{module.icon}</span>
                {module.name}
              </li>
            ))}
          </ul>
        </aside>

        <main className="hjelp-main">
          {activeModule === 'oversikt' && (
            <div className="module-content">
              <h2>🏠 Velkommen til AdvokatCRM</h2>
              <div className="alert alert-success">
                <strong>✅ System Status: Operativt</strong><br />
                Alle 12 hovedmoduler er fullt funksjonelle og deployet i produksjon.
              </div>

              <div className="feature-grid">
                <div className="feature-card">
                  <h3>📁 12 Moduler</h3>
                  <p>Fullstendige moduler for saksbehandling, fakturering, KYC og mer</p>
                </div>
                <div className="feature-card">
                  <h3>🔐 Post-Quantum Sikkerhet</h3>
                  <p>ML-KEM-768 + AES-256-GCM kryptering</p>
                </div>
                <div className="feature-card">
                  <h3>🤖 AI-Drevet</h3>
                  <p>Claude AI for dokumentanalyse og rådgivning</p>
                </div>
                <div className="feature-card">
                  <h3>✅ GDPR-Kompatibel</h3>
                  <p>Audit logging og anonymisering</p>
                </div>
              </div>

              <h3>🎯 Nyeste Funksjoner <span className="badge badge-new">NY</span></h3>
              <ul className="new-features">
                <li>✅ TODO-organisering per sak - Automatisk gruppering</li>
                <li>🔄 Toveis Microsoft-synkronisering - Sync fra To Do til CRM</li>
                <li>📄 Bevis PDF-eksport - Bevisfortegnelser og Chain of Custody</li>
              </ul>

              <div className="quick-links">
                <h3>⚡ Hurtiglenker</h3>
                <button onClick={() => setActiveModule('oppgaver')}>Lær om TODO-organisering</button>
                <button onClick={() => setActiveModule('microsoft')}>Microsoft Integrasjon</button>
                <button onClick={() => setActiveModule('bevis')}>Bevis PDF-eksport</button>
                <button onClick={() => setActiveModule('api')}>API Dokumentasjon</button>
              </div>
            </div>
          )}

          {activeModule === 'oppgaver' && (
            <div className="module-content">
              <h2>✅ Oppgaver & TODO</h2>
              <div className="alert alert-info">
                <strong>🆕 Ny funksjon!</strong><br />
                TODO-organisering per sak er nå tilgjengelig. Se knappen "📋 Se gruppert" i saksoversikten.
              </div>

              <h3>📖 Bruksanvisning</h3>
              <ol className="step-list">
                <li>Gå til en sak i "Saker"-oversikten</li>
                <li>Klikk på "Oppgaver"-fanen</li>
                <li>Oppgaver vises nå gruppert i: E-post, Prosess, Dokument, Utredning</li>
                <li>Se statistikk øverst: Totalt, kritiske frister, e-post som venter</li>
              </ol>

              <h3>🔌 API</h3>
              <pre className="code-block">
GET /api/oppgaver/sak/:sak_id
→ Returnerer oppgaver gruppert per kategori
              </pre>
            </div>
          )}

          {activeModule === 'bevis' && (
            <div className="module-content">
              <h2>🔍 Bevissystem</h2>
              <div className="alert alert-success">
                <strong>📄 PDF-eksport tilgjengelig!</strong><br />
                Generer bevisfortegnelser og Chain of Custody-rapporter.
              </div>

              <h3>📖 Slik eksporterer du PDF</h3>
              <ol className="step-list">
                <li>Gå til "Bevis"-fanen i en sak</li>
                <li>Klikk på "📄 Eksporter bevisfortegnelse" øverst</li>
                <li>PDF åpnes i nytt vindu - bruk Ctrl+P for å printe</li>
                <li>For enkeltbevis: Klikk "📄 Chain of Custody" på beviset</li>
              </ol>

              <h3>🔌 API</h3>
              <pre className="code-block">
GET /api/bevis/pdf/sak/:sak_id     - Bevisfortegnelse
GET /api/bevis/pdf/:bevis_id        - Chain of Custody
              </pre>
            </div>
          )}

          {activeModule === 'microsoft' && (
            <div className="module-content">
              <h2>🔄 Microsoft Integrasjon</h2>
              <div className="alert alert-success">
                <strong>🆕 Toveis sync!</strong><br />
                Synkroniser endringer fra Microsoft To Do tilbake til CRM.
              </div>

              <h3>📖 Bruksanvisning</h3>
              <ol className="step-list">
                <li>Gå til Dashboard eller "Mine Gjøremål"</li>
                <li>Klikk på "🔄 Sync fra Microsoft" knappen</li>
                <li>Systemet henter endringer fra Microsoft To Do</li>
                <li>Status, forfallsdato og prioritet oppdateres automatisk</li>
              </ol>

              <h3>⚙️ Hva synkroniseres?</h3>
              <ul>
                <li>✅ Status (fullført/ikke startet/pågår)</li>
                <li>✅ Forfallsdato</li>
                <li>✅ Prioritet (høy/middels/lav)</li>
              </ul>
            </div>
          )}

          {activeModule === 'api' && (
            <div className="module-content">
              <h2>⚙️ API Dokumentasjon</h2>
              <p>For fullstendig API-dokumentasjon, klikk på knappen øverst for å åpne den interaktive bruksanvisningen.</p>

              <h3>🔑 Autentisering</h3>
              <pre className="code-block">
Authorization: Bearer &lt;token&gt;
              </pre>

              <h3>📡 Base URL</h3>
              <pre className="code-block">
https://advokat-crm-api.stig-958.workers.dev/api
              </pre>

              <h3>🆕 Nye endepunkter</h3>
              <pre className="code-block">
GET  /oppgaver/sak/:sak_id              - TODO-organisering
POST /oppgaver/sync-from-microsoft      - Toveis Microsoft sync
GET  /bevis/pdf/sak/:sak_id             - Bevisfortegnelse PDF
GET  /bevis/pdf/:bevis_id                - Chain of Custody PDF
              </pre>
            </div>
          )}

          {activeModule === 'saker' && (
            <div className="module-content">
              <h2>📁 Saksbehandling</h2>
              <p>Saksbehandlingsmodulen lar deg opprette, administrere og følge opp saker.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>Opprett nye saker med klientinformasjon</li>
                <li>Oppfølging av frister og hendelser</li>
                <li>Dokumenthåndtering med SharePoint-integrasjon</li>
                <li>Tidslinje for saksutviklingen</li>
                <li>Fakturafordeling og rettshjelp</li>
              </ul>
            </div>
          )}

          {activeModule === 'klienter' && (
            <div className="module-content">
              <h2>👥 Klientadministrasjon</h2>
              <p>Administrer klientinformasjon og KYC-data.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>Klientregister med kontaktinformasjon</li>
                <li>KYC-skjemaer og dokumentasjon</li>
                <li>Hvitvaskingssjekker</li>
                <li>Klienthistorikk</li>
              </ul>
            </div>
          )}

          {activeModule === 'epost' && (
            <div className="module-content">
              <h2>📧 E-postsystem</h2>
              <p>Microsoft 365-integrasjon for e-posthåndtering.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>Les e-post fra Microsoft 365</li>
                <li>Koble e-post til saker</li>
                <li>Opprett oppgaver fra e-post</li>
                <li>AI-forslag til oppfølging</li>
              </ul>
            </div>
          )}

          {activeModule === 'faktura' && (
            <div className="module-content">
              <h2>💰 Fakturasystem</h2>
              <p>Automatisk fakturafordeling mellom BKF, innbo og klient.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>Registrer fakturaer med fordeling</li>
                <li>Automatisk beregning basert på forsikring</li>
                <li>Tripletex CSV-eksport</li>
                <li>Budsjettovervåking</li>
              </ul>
            </div>
          )}

          {activeModule === 'tidsregistrering' && (
            <div className="module-content">
              <h2>⏱️ Tidsregistrering</h2>
              <p>Registrer tid brukt på saker.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>Timeføring per sak</li>
                <li>Budsjettestimat vs faktisk</li>
                <li>Tripletex-eksport</li>
                <li>Rapportering</li>
              </ul>
            </div>
          )}

          {activeModule === 'forsikring' && (
            <div className="module-content">
              <h2>🛡️ Forsikring</h2>
              <p>Håndter forsikringsdekning og rettshjelp.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>BKF-dekning (Boligkjøperforsikring)</li>
                <li>Innboforsikring / Rettshjelpsforsikring</li>
                <li>Automatisk fakturafordeling</li>
                <li>Maks beløp og egenandel</li>
              </ul>
            </div>
          )}

          {activeModule === 'kyc' && (
            <div className="module-content">
              <h2>🔐 KYC / Hvitvasking</h2>
              <p>Kundesjekk og hvitvaskingskontroll.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>KYC-skjemaer for klienter</li>
                <li>PEP-sjekker (Politisk Eksponert Person)</li>
                <li>Sanksjonssjekker</li>
                <li>GDPR-anonymisering</li>
              </ul>
            </div>
          )}

          {activeModule === 'ai' && (
            <div className="module-content">
              <h2>🤖 AI & Knowledge Base</h2>
              <p>Claude AI for juridisk assistanse.</p>

              <h3>📖 Funksjoner</h3>
              <ul className="new-features">
                <li>Dokumentanalyse</li>
                <li>E-post oppfølgingsforslag</li>
                <li>Juridisk research</li>
                <li>Rettspraksis-søk</li>
              </ul>
            </div>
          )}

          {/* Legg til flere moduler etter behov */}
        </main>
      </div>

      <div className="hjelp-footer">
        <p>Trenger du mer hjelp? Kontakt support eller åpne den fullstendige bruksanvisningen ovenfor.</p>
      </div>
    </div>
  );
}
